// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3747":"60e483e477a580f5","5223":"2cffba923d9bf0b5","9072":"20d179efce4718fb"}[chunkId] + ".js";
};